/**
 * WHERE a thing physically is - custody, the third independent relationship.
 * A location is a place, not a tenant and not an assignment: an asset owned by
 * HipNumber and rented to Boone County can sit in HipNumber's warehouse (custody
 * here), in transit, or at the tenant's facility, and the answer changes without
 * ownership or assignment changing at all.
 *
 * Some location kinds point at a tenant or an auction (a tenant facility, an
 * auction event); that pointer is a reference, captured for context, never a
 * security boundary. Hardware Operations is operator-owned and global.
 */

export const LOCATION_TYPES = [
  'HIPNUMBER_WAREHOUSE',
  'HIPNUMBER_OFFICE',
  'TENANT_FACILITY',
  'AUCTION_EVENT',
  'EMPLOYEE',
  'IN_TRANSIT',
  'REPAIR_CENTER',
  'THIRD_PARTY',
  'OTHER',
] as const;
export type LocationType = (typeof LOCATION_TYPES)[number];

export const LOCATION_TYPE_LABEL: Readonly<Record<LocationType, string>> = {
  HIPNUMBER_WAREHOUSE: 'HipNumber warehouse',
  HIPNUMBER_OFFICE: 'HipNumber office',
  TENANT_FACILITY: 'Tenant facility',
  AUCTION_EVENT: 'Auction event',
  EMPLOYEE: 'Employee',
  IN_TRANSIT: 'In transit',
  REPAIR_CENTER: 'Repair center',
  THIRD_PARTY: 'Third party',
  OTHER: 'Other',
};

/** Location kinds whose meaning includes a specific tenant. */
export const LOCATION_TYPES_TENANT: readonly LocationType[] = ['TENANT_FACILITY'];

export function isLocationType(v: unknown): v is LocationType {
  return typeof v === 'string' && (LOCATION_TYPES as readonly string[]).includes(v);
}
